"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnsiteMessageThemeWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _constellation = require("@zillow/constellation");

var _getCustomTheme3 = require("../../../themes/ThemeUtils/getCustomTheme");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-confusing-arrow */
var themeCss = function themeCss(_ref) {
  var background = _ref.background,
      fontColor = _ref.fontColor,
      iconColor = _ref.iconColor;
  return (0, _styledComponents.css)(["background:", ";h6,span{color:", ";}svg{color:", ";}", ""], (0, _constellation.token)("colors." + background), (0, _constellation.token)("colors." + fontColor), (0, _constellation.token)("colors." + iconColor), background === 'backgroundDarkBlue' ? "button[class*='StyledTextButton'] {\n            color: #FFF !important;\n        }" : '');
};

var StyledDiv = _styledComponents.default.div.withConfig({
  displayName: "OnsiteMessageThemeWrapper__StyledDiv",
  componentId: "srrtc3-0"
})(["&.omp-theme-wrapper div{", "}"], themeCss);

var OnsiteMessageThemeWrapper = function OnsiteMessageThemeWrapper(_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme;

  var _getCustomTheme = (0, _getCustomTheme3.getCustomTheme)(theme),
      themeToRender = _getCustomTheme.themeToRender;

  if (themeToRender) {
    var _getCustomTheme2 = (0, _getCustomTheme3.getCustomTheme)(theme),
        _getCustomTheme2$them = _getCustomTheme2.themeToRender,
        background = _getCustomTheme2$them.background,
        fontColor = _getCustomTheme2$them.fontColor,
        iconColor = _getCustomTheme2$them.iconColor;

    return /*#__PURE__*/_react.default.createElement(StyledDiv, {
      className: "omp-theme-wrapper",
      background: background,
      fontColor: fontColor,
      iconColor: iconColor
    }, children);
  }

  return null;
};

exports.OnsiteMessageThemeWrapper = OnsiteMessageThemeWrapper;
OnsiteMessageThemeWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node,

  /**
   * The background, font & icon colors within the component. Currently there are 4
   * selectable themes 'backgroundBlue', 'backgroundDarkBlue', 'backgroundWhite' & 'blue200'.
   * */
  theme: _propTypes.default.oneOf(['backgroundBlue', 'backgroundDarkBlue', 'backgroundWhite', 'blue200'])
} : {};
OnsiteMessageThemeWrapper.defaultProps = {
  children: null,
  theme: null
};